import { AlertCircle, LoaderCircle } from "lucide-react";

export function Loading({ label = "正在加载" }: { label?: string }) {
  return (
    <div className="state-card">
      <LoaderCircle className="spin" size={22} />
      <span>{label}</span>
    </div>
  );
}

export function ErrorCard({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="state-card state-card--error">
      <AlertCircle size={22} />
      <span>{message}</span>
      {retry && (
        <button className="text-button" onClick={retry}>
          重试
        </button>
      )}
    </div>
  );
}
